import React, { Fragment } from 'react';
import { Container, Row, Col } from 'reactstrap';
import HeaderLogo from '../../sharedComponents/Header/HeaderLogo';
import useAdminLogin from './useAdminLogin';
import AdminLoginForm from './AdminLoginForm';

const AdminLogin = () => {
  const adminLoginFormProps = useAdminLogin();
  const logo = localStorage.getItem('branding') === "ARROWSTREAM" ? './arrowstreamLogoWhite.png' : process.env.REACT_APP_COMPANY_LOGO;

  document.body.style.backgroundImage= 'none';

  return (
    <Fragment>
      <HeaderLogo logo={logo} />
      <Container fluid className='flex-grow-1'>
        <Row className='justify-content-center'>
          <Col style={{maxWidth: '600px'}}>
            <Row className='py-5'>
              <Col className='text-center text-size-36 main-header'>Admin Login</Col>
            </Row>
            <AdminLoginForm {...adminLoginFormProps} />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default AdminLogin;